import { render } from "./PolaroidPhoto.vue?vue&type=template&id=417d88d2&scoped=true&ts=true"
import script from "./PolaroidPhoto.vue?vue&type=script&lang=ts"
export * from "./PolaroidPhoto.vue?vue&type=script&lang=ts"

import "./PolaroidPhoto.vue?vue&type=style&index=0&id=417d88d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417d88d2"]])

export default __exports__